
























import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {DisguiseRoute} from '@/routetype';
import {BehaviorSubject} from 'rxjs';

@Component
export default class CompositeTemplate extends Vue {

  expandedPanelIndices: number[] = [];

  @Prop({
    default: () => {
      return [];
    }
  }) children!: DisguiseRoute[]; // comes from navi service
  @Prop({
    default: null
  }) userRequestedReload!: BehaviorSubject<string> | null; // whenever a user requests a reload, e.g. by submenu tab

  created() {
    for (let i = 0; i < this.children.length; i++) {
      this.expandedPanelIndices.push(i);
    }
  }

  @Watch('children') childrenChanged(newValue: DisguiseRoute[]) {
    Vue.nextTick(() => {
      const newExpandedPanelIndices: number[] = [];
      for (let i = 0; i < newValue.length; i++) {
        newExpandedPanelIndices.push(i);
      }
      this.expandedPanelIndices = newExpandedPanelIndices;
    });
  }

  close() {
    this.$emit('close');
  }

}
